if (!customElements.get('recommended-products')) {
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      // Wait for Swiper library to load
      if (typeof Swiper !== 'undefined') {
        this.initSwiper();
      } else {
        // Retry after a short delay if Swiper is not loaded yet
        setTimeout(() => this.connectedCallback(), 100);
      }
    }

    initSwiper() {
      const slider = this.querySelector('.swiper');
      if (!slider || this.swiperInstance) return;

      const nextButton = this.querySelector('.swiper-button-next');
      const prevButton = this.querySelector('.swiper-button-prev');
      const pagination = this.querySelector('.swiper-pagination');

      // Get settings from data attributes
      const desktopColumns = parseFloat(this.dataset.desktopColumns) || 4;
      const mobileColumns = parseFloat(this.dataset.mobileColumns) || 1.2;
      const gap = parseInt(this.dataset.gap) || 24;
      const gapMobile = parseInt(this.dataset.gapMobile) || 16;

      this.swiperInstance = new Swiper(slider, {
        slidesPerView: mobileColumns,
        spaceBetween: gapMobile,
        loop: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
          type: 'bullets',
          dynamicBullets: false,
        },
        breakpoints: {
          640: { 
            slidesPerView: Math.min(desktopColumns, 2), 
            spaceBetween: gap 
          },
          768: { 
            slidesPerView: Math.min(desktopColumns, 3), 
            spaceBetween: gap 
          },
          1024: { 
            slidesPerView: desktopColumns, 
            spaceBetween: gap 
          }
        },
        on: {
          init: function() {
            console.log('Recommended Products Swiper initialized');
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  customElements.define('recommended-products', RecommendedProducts);
}
